import { numberToWords } from '@persian-tools/persian-tools';
import { IconFileTypePdf } from '@tabler/icons-react';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Box } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ISampleQuestions } from '@/Module/Lesson/Constant';
interface ILessonSampleQuestionProps {
  courseId: number;
  sampleQuestions: ISampleQuestions[];
}
const LessonSampleQuestion: FC<ILessonSampleQuestionProps> = ({
  courseId,
  sampleQuestions
}) => {
  const imageWidth = 346;
  const imageHeight = imageWidth / 1.783;
  const imageUrl = useMemo(() => {
    if (!courseId) return `${FILE_BROWSER_URL}/img/img-lesson-default.webp`;
    return `${FILE_BROWSER_URL}/course/${courseId}.webp`;
  }, [courseId]);
  return <div className="container mb-4" data-sentry-component="LessonSampleQuestion" data-sentry-source-file="LessonSampleQuestion.tsx">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-4">
        {sampleQuestions.map(file => <div key={file.id} dir="rtl">
            <Link href={`https://asset.hamrah.academy/filebrowser/api/public/dl/5WF3MNiI/files/sample-questions/${courseId}/${file.id}.pdf`} key={file.title} target="_blank" rel="noopener noreferrer">
              <Box color="lightOrange" className="relative mb-5 overflow-hidden p-1 group-hover:shadow-themeHover group-hover:shadow-orangeFour">
                <Image width={imageWidth} height={imageHeight} className="z-0 w-full" src={imageUrl} alt={file.title} />
                <div className="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-[rgba(69,41,4,.52)] transition-all group-hover:bg-transparent">
                  <IconFileTypePdf className="h-16 w-16 rounded-full bg-white/50 p-2 text-white transition-all group-hover:scale-110 group-hover:bg-orangeFour" />
                </div>
              </Box>

              <span className="mb-1 font-bold text-orangeFive group-hover:text-orangeSix lg:text-lg">
                <span className="ml-1 inline text-base font-normal">
                  نمونه سوال {numberToWords(file.id, {
                ordinal: true
              }) as string}:
                </span>
                <span className="inline text-base">{file.title}</span>
              </span>
            </Link>
          </div>)}
      </div>
    </div>;
};
export default LessonSampleQuestion;